var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};

// src/utils/Enums.ts
var TiposVisitaSegunUbicacion = /* @__PURE__ */ function(TiposVisitaSegunUbicacion2) {
  TiposVisitaSegunUbicacion2[TiposVisitaSegunUbicacion2["Cliente_o_establecimiento_sin_ubicaci\xF3n"] = 1] = "Cliente_o_establecimiento_sin_ubicaci\xF3n";
  TiposVisitaSegunUbicacion2[TiposVisitaSegunUbicacion2["Visita_sin_ubicacion"] = 2] = "Visita_sin_ubicacion";
  TiposVisitaSegunUbicacion2[TiposVisitaSegunUbicacion2["Ubicacion_dentro_del_perimetro_permitido"] = 3] = "Ubicacion_dentro_del_perimetro_permitido";
  TiposVisitaSegunUbicacion2[TiposVisitaSegunUbicacion2["Ubicacion_fuera_del_perimetro_permitido"] = 4] = "Ubicacion_fuera_del_perimetro_permitido";
  return TiposVisitaSegunUbicacion2;
}({});
var Movs = /* @__PURE__ */ function(Movs2) {
  Movs2[Movs2["VENTA"] = 0] = "VENTA";
  Movs2[Movs2["ANULACION_DEVOLUCION_VENTA"] = 0] = "ANULACION_DEVOLUCION_VENTA";
  Movs2[Movs2["AJUSTE_EGRESO"] = 0] = "AJUSTE_EGRESO";
  Movs2[Movs2["DEVOLUCION_COMPRA"] = 0] = "DEVOLUCION_COMPRA";
  Movs2[Movs2["ANULACION_COMPRA"] = 0] = "ANULACION_COMPRA";
  Movs2[Movs2["ANULACION_AJUSTE_INGRESO"] = 0] = "ANULACION_AJUSTE_INGRESO";
  Movs2[Movs2["PLAN_ACUMULATIVO"] = 2] = "PLAN_ACUMULATIVO";
  Movs2[Movs2["ORDEN_PEDIDO"] = 4] = "ORDEN_PEDIDO";
  Movs2[Movs2["APROBACION_ORDEN_PEDIDO"] = 6] = "APROBACION_ORDEN_PEDIDO";
  Movs2[Movs2["FACTURACION_ORDEN_PEDIDO"] = 7] = "FACTURACION_ORDEN_PEDIDO";
  Movs2[Movs2["ANULACION_APROBACION_ORDEN_PEDIDO"] = 8] = "ANULACION_APROBACION_ORDEN_PEDIDO";
  Movs2[Movs2["ANULACION_FACTURACION_ORDEN_PEDIDO"] = 9] = "ANULACION_FACTURACION_ORDEN_PEDIDO";
  Movs2[Movs2["COMPRA"] = 1] = "COMPRA";
  Movs2[Movs2["ANULACION_DEVOLUCION_COMPRA"] = 1] = "ANULACION_DEVOLUCION_COMPRA";
  Movs2[Movs2["AJUSTE_INGRESO"] = 1] = "AJUSTE_INGRESO";
  Movs2[Movs2["DEVOLUCION_VENTA"] = 1] = "DEVOLUCION_VENTA";
  Movs2[Movs2["ANULACION_VENTA"] = 1] = "ANULACION_VENTA";
  Movs2[Movs2["ANULACION_AJUSTE_EGRESO"] = 1] = "ANULACION_AJUSTE_EGRESO";
  Movs2[Movs2["ANULACION_PLAN_ACUMULATIVO"] = 3] = "ANULACION_PLAN_ACUMULATIVO";
  Movs2[Movs2["ANULACION_ORDEN_PEDIDO"] = 5] = "ANULACION_ORDEN_PEDIDO";
  Movs2[Movs2["ORDEN_PEDIDO_REPROCESAR"] = 10] = "ORDEN_PEDIDO_REPROCESAR";
  return Movs2;
}({});
var NivelLog = /* @__PURE__ */ function(NivelLog2) {
  NivelLog2["Info"] = "INFO";
  NivelLog2["Verbose"] = "VERBOSE";
  return NivelLog2;
}({});
var LogisticaTipoConversion = /* @__PURE__ */ function(LogisticaTipoConversion2) {
  LogisticaTipoConversion2[LogisticaTipoConversion2["Flete_al_cobro_en_gu\xEDa"] = 1] = "Flete_al_cobro_en_gu\xEDa";
  return LogisticaTipoConversion2;
}({});
var LogisticaEstadoConversion = /* @__PURE__ */ function(LogisticaEstadoConversion2) {
  LogisticaEstadoConversion2[LogisticaEstadoConversion2["Pendiente"] = 1] = "Pendiente";
  LogisticaEstadoConversion2[LogisticaEstadoConversion2["Aprobado"] = 2] = "Aprobado";
  LogisticaEstadoConversion2[LogisticaEstadoConversion2["Rechazado"] = 3] = "Rechazado";
  return LogisticaEstadoConversion2;
}({});
var LogisticaManifiestoDetalleEstado = /* @__PURE__ */ function(LogisticaManifiestoDetalleEstado2) {
  LogisticaManifiestoDetalleEstado2["Activo"] = "A";
  LogisticaManifiestoDetalleEstado2["Recibido"] = "R";
  LogisticaManifiestoDetalleEstado2["Conflicto"] = "C";
  LogisticaManifiestoDetalleEstado2["Entregada"] = "E";
  LogisticaManifiestoDetalleEstado2["Devuelta"] = "D";
  LogisticaManifiestoDetalleEstado2["Pendiente"] = "P";
  LogisticaManifiestoDetalleEstado2["RecibidoEnBodegaTransito"] = "T";
  LogisticaManifiestoDetalleEstado2["EnRuta"] = "U";
  LogisticaManifiestoDetalleEstado2["EnViajeDesdeBodegaTransito"] = "B";
  LogisticaManifiestoDetalleEstado2["Anulado"] = "I";
  return LogisticaManifiestoDetalleEstado2;
}({});
var TiposEmision = /* @__PURE__ */ function(TiposEmision2) {
  TiposEmision2["Fisico"] = "F";
  TiposEmision2["Electronico"] = "E";
  return TiposEmision2;
}({});
var ConfiguracionesCorreo = /* @__PURE__ */ function(ConfiguracionesCorreo2) {
  ConfiguracionesCorreo2["Gmail"] = "gmail";
  ConfiguracionesCorreo2["Hotmail"] = "hotmail";
  ConfiguracionesCorreo2["AWS_SES"] = "aws";
  ConfiguracionesCorreo2["Personalizado"] = "personalizado";
  return ConfiguracionesCorreo2;
}({});
var TiposIdentificacion = /* @__PURE__ */ function(TiposIdentificacion2) {
  TiposIdentificacion2[TiposIdentificacion2["RUC"] = 1] = "RUC";
  TiposIdentificacion2[TiposIdentificacion2["Cedula"] = 2] = "Cedula";
  TiposIdentificacion2[TiposIdentificacion2["Pasaporte"] = 3] = "Pasaporte";
  return TiposIdentificacion2;
}({});
function ExisteEnEnum(Enum, valor) {
  if (Object.values(Enum).includes(valor)) {
    return true;
  }
  return false;
}
__name(ExisteEnEnum, "ExisteEnEnum");
var LogisticaTiposRango = /* @__PURE__ */ function(LogisticaTiposRango2) {
  LogisticaTiposRango2["Factura"] = "F";
  LogisticaTiposRango2["Cliente"] = "C";
  LogisticaTiposRango2["Usuario"] = "U";
  return LogisticaTiposRango2;
}({});
var LogisticaGuiaProformaEstado = /* @__PURE__ */ function(LogisticaGuiaProformaEstado2) {
  LogisticaGuiaProformaEstado2["Liberado"] = "L";
  LogisticaGuiaProformaEstado2["Pendiente"] = "Q";
  LogisticaGuiaProformaEstado2["Convertido"] = "K";
  return LogisticaGuiaProformaEstado2;
}({});
var LogisticaManifiestoProformaEstado = /* @__PURE__ */ function(LogisticaManifiestoProformaEstado2) {
  LogisticaManifiestoProformaEstado2["Todos"] = "0";
  LogisticaManifiestoProformaEstado2["Pendiente"] = "P";
  LogisticaManifiestoProformaEstado2["Convertido"] = "C";
  LogisticaManifiestoProformaEstado2["Anulado"] = "I";
  return LogisticaManifiestoProformaEstado2;
}({});
var LogisticaGuiaEstado = /* @__PURE__ */ function(LogisticaGuiaEstado2) {
  LogisticaGuiaEstado2["Planta"] = "P";
  LogisticaGuiaEstado2["Viaje"] = "V";
  LogisticaGuiaEstado2["Recibido"] = "R";
  LogisticaGuiaEstado2["Conflicto"] = "C";
  LogisticaGuiaEstado2["Entregada"] = "E";
  LogisticaGuiaEstado2["Devuelta"] = "D";
  LogisticaGuiaEstado2["Ruta"] = "U";
  LogisticaGuiaEstado2["Anulado"] = "I";
  LogisticaGuiaEstado2["RecibidoEnBodegaTransito"] = "T";
  LogisticaGuiaEstado2["EnViajeBodegaTransito"] = "B";
  LogisticaGuiaEstado2["Todos"] = "0";
  return LogisticaGuiaEstado2;
}({});
var LogisticaTiposEntrega = /* @__PURE__ */ function(LogisticaTiposEntrega2) {
  LogisticaTiposEntrega2["Domicilio"] = "D";
  LogisticaTiposEntrega2["RetiroOficina"] = "O";
  return LogisticaTiposEntrega2;
}({});
var LogisticaTiposFormaPago = /* @__PURE__ */ function(LogisticaTiposFormaPago2) {
  LogisticaTiposFormaPago2["Contado"] = "T";
  LogisticaTiposFormaPago2["Credito"] = "C";
  LogisticaTiposFormaPago2["FleteCobro"] = "F";
  LogisticaTiposFormaPago2["Todos"] = "0";
  return LogisticaTiposFormaPago2;
}({});
var LogisticaTipoFormaPagoDominio = class {
  constructor(id, descripcion, abreviatura) {
    __publicField(this, "id");
    __publicField(this, "descripcion");
    __publicField(this, "abreviatura");
    this.id = id;
    this.descripcion = descripcion;
    this.abreviatura = abreviatura;
  }
  static obtener(tipo) {
    switch (tipo) {
      case "T":
        return new LogisticaTipoFormaPagoDominio(tipo, "Contado", "T");
      case "C":
        return new LogisticaTipoFormaPagoDominio(tipo, "Cr\xE9dito", "C");
      case "F":
        return new LogisticaTipoFormaPagoDominio(tipo, "Flete al Cobro", "F");
      case "0":
        return new LogisticaTipoFormaPagoDominio(tipo, "Todos", "0");
    }
  }
};
__name(LogisticaTipoFormaPagoDominio, "LogisticaTipoFormaPagoDominio");
var SriDocs = /* @__PURE__ */ function(SriDocs2) {
  SriDocs2[SriDocs2["TODOS"] = 0] = "TODOS";
  SriDocs2[SriDocs2["Factura"] = 4] = "Factura";
  SriDocs2[SriDocs2["Nota_venta"] = 5] = "Nota_venta";
  SriDocs2[SriDocs2["Liquidaci\xF3n_compras"] = 6] = "Liquidaci\xF3n_compras";
  SriDocs2[SriDocs2["Nota_credito"] = 7] = "Nota_credito";
  SriDocs2[SriDocs2["Nota_D\xE9bito"] = 8] = "Nota_D\xE9bito";
  SriDocs2[SriDocs2["Guia_Remisi\xF3n"] = 20] = "Guia_Remisi\xF3n";
  SriDocs2[SriDocs2["Rentenci\xF3n"] = 21] = "Rentenci\xF3n";
  SriDocs2[SriDocs2["Boleto"] = 9] = "Boleto";
  SriDocs2[SriDocs2["Tiquet"] = 10] = "Tiquet";
  SriDocs2[SriDocs2["Comprobante_Venta_Emitido_Por_Reembolso"] = 17] = "Comprobante_Venta_Emitido_Por_Reembolso";
  SriDocs2[SriDocs2["RET_332"] = 36] = "RET_332";
  SriDocs2[SriDocs2["RET_333"] = 37] = "RET_333";
  SriDocs2[SriDocs2["RET_334"] = 38] = "RET_334";
  return SriDocs2;
}({});
var Docs = /* @__PURE__ */ function(Docs2) {
  Docs2[Docs2["TODOS"] = 0] = "TODOS";
  Docs2[Docs2["FACTURA"] = 1] = "FACTURA";
  Docs2[Docs2["PROFORMA"] = 2] = "PROFORMA";
  Docs2[Docs2["COMPROBANTE_DE_VENTA"] = 3] = "COMPROBANTE_DE_VENTA";
  Docs2[Docs2["COMPRA"] = 4] = "COMPRA";
  Docs2[Docs2["AD_REEMBOLSO"] = 5] = "AD_REEMBOLSO";
  Docs2[Docs2["INGRESO"] = 6] = "INGRESO";
  Docs2[Docs2["AJ_INGRESO"] = 7] = "AJ_INGRESO";
  Docs2[Docs2["AJ_EGRESO"] = 8] = "AJ_EGRESO";
  Docs2[Docs2["EGRESO"] = 9] = "EGRESO";
  Docs2[Docs2["AD_REFERENCIA"] = 10] = "AD_REFERENCIA";
  Docs2[Docs2["NOTA_DE_CREDITO"] = 11] = "NOTA_DE_CREDITO";
  Docs2[Docs2["NOTA_DE_DEBITO"] = 12] = "NOTA_DE_DEBITO";
  Docs2[Docs2["CRUCE_VENTAS"] = 13] = "CRUCE_VENTAS";
  Docs2[Docs2["NOTA_DE_CREDITO_CXP"] = 15] = "NOTA_DE_CREDITO_CXP";
  Docs2[Docs2["NOTA_DE_DEBITO_CXP"] = 16] = "NOTA_DE_DEBITO_CXP";
  Docs2[Docs2["CRUCE_COMPRAS"] = 17] = "CRUCE_COMPRAS";
  Docs2[Docs2["RETENCION_EN_VENTA"] = 18] = "RETENCION_EN_VENTA";
  Docs2[Docs2["RETENCION_EN_COMPRA"] = 19] = "RETENCION_EN_COMPRA";
  Docs2[Docs2["LIQUIDACION_COMPRAS"] = 20] = "LIQUIDACION_COMPRAS";
  Docs2[Docs2["PLAN_ACUMULATIVO"] = 21] = "PLAN_ACUMULATIVO";
  Docs2[Docs2["CHEQUE_CXC"] = 22] = "CHEQUE_CXC";
  Docs2[Docs2["CHEQUE_CXP"] = 23] = "CHEQUE_CXP";
  Docs2[Docs2["DEPOSITO_CHEQUES"] = 24] = "DEPOSITO_CHEQUES";
  Docs2[Docs2["CHEQUE_PROTESTADO_CXC"] = 25] = "CHEQUE_PROTESTADO_CXC";
  Docs2[Docs2["COMPRA_EXTERIOR"] = 26] = "COMPRA_EXTERIOR";
  Docs2[Docs2["NOMINA"] = 27] = "NOMINA";
  Docs2[Docs2["ENVIO_CONSIGNACION"] = 28] = "ENVIO_CONSIGNACION";
  Docs2[Docs2["DEVOLUCION_CONSIGNACION"] = 29] = "DEVOLUCION_CONSIGNACION";
  Docs2[Docs2["LIQUIDACION_DE_SOCIOS"] = 30] = "LIQUIDACION_DE_SOCIOS";
  Docs2[Docs2["PRESTAMO_SOCIOS"] = 31] = "PRESTAMO_SOCIOS";
  Docs2[Docs2["ANTICIPO_SOCIOS"] = 32] = "ANTICIPO_SOCIOS";
  Docs2[Docs2["LIQUIDACION_ANTICIPO_SOCIOS"] = 33] = "LIQUIDACION_ANTICIPO_SOCIOS";
  Docs2[Docs2["OBLIGACION_SOCIOS"] = 34] = "OBLIGACION_SOCIOS";
  Docs2[Docs2["PRODUCCION"] = 35] = "PRODUCCION";
  Docs2[Docs2["TOMA_FISICA_INVENTARIO"] = 36] = "TOMA_FISICA_INVENTARIO";
  Docs2[Docs2["VENTA_DIFERIDA"] = 37] = "VENTA_DIFERIDA";
  Docs2[Docs2["GUIA_TRANSPORTE"] = 38] = "GUIA_TRANSPORTE";
  Docs2[Docs2["GUIA_REMISION"] = 39] = "GUIA_REMISION";
  Docs2[Docs2["ANTICIPO_EN_GUIAS"] = 40] = "ANTICIPO_EN_GUIAS";
  Docs2[Docs2["CIERRE_CAJA"] = 41] = "CIERRE_CAJA";
  Docs2[Docs2["ORDEN_DE_PEDIDO"] = 42] = "ORDEN_DE_PEDIDO";
  Docs2[Docs2["LIBERACION_CREDITO_MOROSIDAD"] = 43] = "LIBERACION_CREDITO_MOROSIDAD";
  Docs2[Docs2["DEVOLUCION_DINERO"] = 44] = "DEVOLUCION_DINERO";
  Docs2[Docs2["INGRESO_REEMBOLSO_CXC"] = 45] = "INGRESO_REEMBOLSO_CXC";
  Docs2[Docs2["LIQUIDACION_CLIENTE_A"] = 46] = "LIQUIDACION_CLIENTE_A";
  Docs2[Docs2["ORDEN_MANUFACTURA"] = 47] = "ORDEN_MANUFACTURA";
  Docs2[Docs2["LIQUIDACION_POMADA"] = 48] = "LIQUIDACION_POMADA";
  Docs2[Docs2["MANIFIESTO_LOGISTICA"] = 49] = "MANIFIESTO_LOGISTICA";
  Docs2[Docs2["RUTA_DE_ENTREGA"] = 50] = "RUTA_DE_ENTREGA";
  Docs2[Docs2["VALE_CAJA"] = 54] = "VALE_CAJA";
  Docs2[Docs2["DEVOLUCION_DINERO_CXP"] = 55] = "DEVOLUCION_DINERO_CXP";
  Docs2[Docs2["ORDEN_TRABAJO"] = 56] = "ORDEN_TRABAJO";
  Docs2[Docs2["ORDEN_COMPRA"] = 57] = "ORDEN_COMPRA";
  Docs2[Docs2["VIAJE"] = 58] = "VIAJE";
  Docs2[Docs2["LIQUIDACION_CONSIGNACIONES"] = 59] = "LIQUIDACION_CONSIGNACIONES";
  Docs2[Docs2["TRANSFERENCIA"] = 60] = "TRANSFERENCIA";
  Docs2[Docs2["ANEXO_DE_FACTURACION_RENTING"] = 61] = "ANEXO_DE_FACTURACION_RENTING";
  Docs2[Docs2["ORDEN_SERVICIOS_RENTING"] = 62] = "ORDEN_SERVICIOS_RENTING";
  Docs2[Docs2["CARGO_BANCO_SANGRE"] = 63] = "CARGO_BANCO_SANGRE";
  Docs2[Docs2["LIQUIDACION_PAGO_BANCO_SANGRE"] = 64] = "LIQUIDACION_PAGO_BANCO_SANGRE";
  Docs2[Docs2["GUIA_ARROZ"] = 65] = "GUIA_ARROZ";
  Docs2[Docs2["EXPLOSION"] = 66] = "EXPLOSION";
  Docs2[Docs2["EMPAQUETADO"] = 67] = "EMPAQUETADO";
  Docs2[Docs2["FICHA"] = 68] = "FICHA";
  Docs2[Docs2["ORDEN_TRABAJO_LOGISTICA"] = 69] = "ORDEN_TRABAJO_LOGISTICA";
  Docs2[Docs2["PROYECTO"] = 70] = "PROYECTO";
  Docs2[Docs2["PEDIDO"] = 71] = "PEDIDO";
  Docs2[Docs2["PAGO_SENAE"] = 71] = "PAGO_SENAE";
  Docs2[Docs2["LIQUIDACION_SENAE"] = 72] = "LIQUIDACION_SENAE";
  Docs2[Docs2["PEDIDO_INTERNO"] = 73] = "PEDIDO_INTERNO";
  Docs2[Docs2["MANIFIESTO_ADUANA"] = 74] = "MANIFIESTO_ADUANA";
  Docs2[Docs2["ORDEN_ESTIBA_LOGISTICA"] = 71] = "ORDEN_ESTIBA_LOGISTICA";
  Docs2[Docs2["ORDEN_PEDIDO_RESPALDO"] = 75] = "ORDEN_PEDIDO_RESPALDO";
  Docs2[Docs2["ORDEN_SERVICIO_GUIAS_TRANSPORTE"] = 76] = "ORDEN_SERVICIO_GUIAS_TRANSPORTE";
  Docs2[Docs2["TRANSFERENCIA_EMITIDA"] = 77] = "TRANSFERENCIA_EMITIDA";
  Docs2[Docs2["ANTICIPO_RECIBIDO"] = 98] = "ANTICIPO_RECIBIDO";
  Docs2[Docs2["GASTOS_CAJA"] = 99] = "GASTOS_CAJA";
  Docs2[Docs2["ANTICIPO_EMITIDO"] = 100] = "ANTICIPO_EMITIDO";
  Docs2[Docs2["INGRESOS_CAJA"] = 101] = "INGRESOS_CAJA";
  Docs2[Docs2["REPORTE_CAJA"] = 102] = "REPORTE_CAJA";
  Docs2[Docs2["PAGO_MASIVO_EMPLEADO"] = 103] = "PAGO_MASIVO_EMPLEADO";
  Docs2[Docs2["GUIA_ARROZ_kg"] = 104] = "GUIA_ARROZ_kg";
  Docs2[Docs2["CRUCE_GENERAL"] = 105] = "CRUCE_GENERAL";
  Docs2[Docs2["FACTURA_RECURRENTE"] = 106] = "FACTURA_RECURRENTE";
  Docs2[Docs2["CONTRATO"] = 107] = "CONTRATO";
  return Docs2;
}({});
var DocumentoDominio = class {
  constructor(docs, descripcion, abreviatura, nombrePlural, requiereAutorizacionSRI, ingresoInventario) {
    __publicField(this, "docs");
    __publicField(this, "descripcion");
    __publicField(this, "abreviatura");
    __publicField(this, "nombrePlural");
    __publicField(this, "requiereAutorizacionSRI");
    __publicField(this, "ingresoInventario");
    this.docs = docs;
    this.descripcion = descripcion;
    this.abreviatura = abreviatura;
    this.nombrePlural = nombrePlural;
    this.requiereAutorizacionSRI = requiereAutorizacionSRI;
    this.ingresoInventario = ingresoInventario;
  }
  get id() {
    return this.docs;
  }
  static obtener(doc) {
    switch (doc) {
      case 1:
        return new DocumentoDominio(doc, "Factura", "FAC", "Facturas", true, false);
      case 2:
        return new DocumentoDominio(doc, "Proforma", "PRF", "Proformas", false, false);
      case 3:
        return new DocumentoDominio(doc, "Comprobante de venta", "CV", "Comprobantes de venta", false, false);
      case 38:
        return new DocumentoDominio(doc, "Gu\xEDa de transporte", "GTR", "Gu\xEDas de transporte", false, false);
      case 0:
        return new DocumentoDominio(doc, "Todos", "ALL", "Todos", false, false);
      default:
        throw new Error(`Documento no manejado: ${doc}`);
    }
  }
};
__name(DocumentoDominio, "DocumentoDominio");
var ContaDocs = /* @__PURE__ */ function(ContaDocs2) {
  ContaDocs2[ContaDocs2["INGRESO"] = 1] = "INGRESO";
  ContaDocs2[ContaDocs2["EGRESO"] = 2] = "EGRESO";
  ContaDocs2[ContaDocs2["FACTURA"] = 3] = "FACTURA";
  ContaDocs2[ContaDocs2["COMPROBANTE_DE_EGRESO"] = 4] = "COMPROBANTE_DE_EGRESO";
  ContaDocs2[ContaDocs2["DIARIOS"] = 5] = "DIARIOS";
  ContaDocs2[ContaDocs2["DEPOSITOS"] = 6] = "DEPOSITOS";
  ContaDocs2[ContaDocs2["COMPROBANTE_DE_VENTA"] = 7] = "COMPROBANTE_DE_VENTA";
  ContaDocs2[ContaDocs2["NOTA_DE_VENTA"] = 8] = "NOTA_DE_VENTA";
  ContaDocs2[ContaDocs2["COMPROBANTE_DE_INGRESO"] = 9] = "COMPROBANTE_DE_INGRESO";
  ContaDocs2[ContaDocs2["OBLIGACION_SOCIOS"] = 10] = "OBLIGACION_SOCIOS";
  ContaDocs2[ContaDocs2["COMPRA"] = 11] = "COMPRA";
  ContaDocs2[ContaDocs2["LIQUIDACI\xD3N_DE_COMPRAS"] = 12] = "LIQUIDACI\xD3N_DE_COMPRAS";
  ContaDocs2[ContaDocs2["AJUSTE_EGRESO"] = 13] = "AJUSTE_EGRESO";
  ContaDocs2[ContaDocs2["NOTA_DE_CR\xC9DITO_CXC"] = 14] = "NOTA_DE_CR\xC9DITO_CXC";
  ContaDocs2[ContaDocs2["NOTA_DE_CR\xC9DITO_CXP"] = 15] = "NOTA_DE_CR\xC9DITO_CXP";
  ContaDocs2[ContaDocs2["NOTA_DE_D\xC9BITO_CXC"] = 16] = "NOTA_DE_D\xC9BITO_CXC";
  ContaDocs2[ContaDocs2["NOTA_DE_D\xC9BITO_CXP"] = 17] = "NOTA_DE_D\xC9BITO_CXP";
  ContaDocs2[ContaDocs2["AJUSTE_INGRESO"] = 18] = "AJUSTE_INGRESO";
  ContaDocs2[ContaDocs2["CRUCE_CXC"] = 19] = "CRUCE_CXC";
  ContaDocs2[ContaDocs2["CRUCE_CXP"] = 20] = "CRUCE_CXP";
  ContaDocs2[ContaDocs2["PLAN_ACUMULATIVO"] = 21] = "PLAN_ACUMULATIVO";
  ContaDocs2[ContaDocs2["NOMINA"] = 22] = "NOMINA";
  ContaDocs2[ContaDocs2["DEPRECIACION"] = 23] = "DEPRECIACION";
  ContaDocs2[ContaDocs2["GASTOS_CAJA"] = 24] = "GASTOS_CAJA";
  ContaDocs2[ContaDocs2["INGRESO_IMPORTACION"] = 25] = "INGRESO_IMPORTACION";
  ContaDocs2[ContaDocs2["COMPRA_EXTERIOR"] = 26] = "COMPRA_EXTERIOR";
  ContaDocs2[ContaDocs2["LIQUIDACION_DE_SOCIOS"] = 27] = "LIQUIDACION_DE_SOCIOS";
  ContaDocs2[ContaDocs2["PRESTAMO_SOCIOS"] = 28] = "PRESTAMO_SOCIOS";
  ContaDocs2[ContaDocs2["ANTICIPO_SOCIOS"] = 29] = "ANTICIPO_SOCIOS";
  ContaDocs2[ContaDocs2["LIQUIDACION_ANTICIPO_SOCIOS"] = 30] = "LIQUIDACION_ANTICIPO_SOCIOS";
  ContaDocs2[ContaDocs2["LIQUIDACION_POMADA"] = 31] = "LIQUIDACION_POMADA";
  ContaDocs2[ContaDocs2["GUIA_ARROZ"] = 32] = "GUIA_ARROZ";
  ContaDocs2[ContaDocs2["EXPLOSION"] = 33] = "EXPLOSION";
  ContaDocs2[ContaDocs2["EMPAQUETADO"] = 34] = "EMPAQUETADO";
  ContaDocs2[ContaDocs2["INGRESOS_CAJA"] = 35] = "INGRESOS_CAJA";
  ContaDocs2[ContaDocs2["PAGO_SENAE"] = 36] = "PAGO_SENAE";
  ContaDocs2[ContaDocs2["LIQUIDACION_SENAE"] = 37] = "LIQUIDACION_SENAE";
  ContaDocs2[ContaDocs2["CARGO_BANCO_SANGRE"] = 36] = "CARGO_BANCO_SANGRE";
  ContaDocs2[ContaDocs2["BAJA_ACTIVOS_FIJOS"] = 38] = "BAJA_ACTIVOS_FIJOS";
  ContaDocs2[ContaDocs2["SALDO_INICIAL"] = 39] = "SALDO_INICIAL";
  ContaDocs2[ContaDocs2["RETENCION_COMPRA"] = 100] = "RETENCION_COMPRA";
  return ContaDocs2;
}({});
var ConfiguracionesEmpresa = /* @__PURE__ */ function(ConfiguracionesEmpresa2) {
  ConfiguracionesEmpresa2["ruc"] = "ruc";
  ConfiguracionesEmpresa2["razonSocial"] = "razonSocial";
  ConfiguracionesEmpresa2["direccion"] = "direccion";
  ConfiguracionesEmpresa2["lineasFactura"] = "lineasFactura";
  ConfiguracionesEmpresa2["ValidarCedulaRuc"] = "ValidarCedulaRuc";
  ConfiguracionesEmpresa2["NumeroRetencionEditable"] = "NumeroRetencionEditable";
  ConfiguracionesEmpresa2["telefono"] = "telefono";
  ConfiguracionesEmpresa2["ciudad"] = "ciudad";
  ConfiguracionesEmpresa2["informacion"] = "informacion";
  ConfiguracionesEmpresa2["precio"] = "precio";
  ConfiguracionesEmpresa2["pagaIvaComprobante"] = "pagaIvaComprobante";
  ConfiguracionesEmpresa2["pvpModificable"] = "pvpModificable";
  ConfiguracionesEmpresa2["descripcionModificable"] = "descripcionModificable";
  ConfiguracionesEmpresa2["alertarStockMinimo"] = "alertarStockMinimo";
  ConfiguracionesEmpresa2["impedir_ingreso_mercaderia_con_costo_0"] = "impedir_ingreso_mercaderia_con_costo_0";
  ConfiguracionesEmpresa2["mesas"] = "mesas";
  ConfiguracionesEmpresa2["version"] = "version";
  ConfiguracionesEmpresa2["FPNotaCredito"] = "FPNotaCredito";
  ConfiguracionesEmpresa2["PermitirExistenciasNegativas"] = "PermitirExistenciasNegativas";
  ConfiguracionesEmpresa2["SIACAD"] = "SIACAD";
  ConfiguracionesEmpresa2["SIACADFotos"] = "SIACADFotos";
  ConfiguracionesEmpresa2["nombreComercial"] = "nombreComercial";
  ConfiguracionesEmpresa2["email"] = "email";
  ConfiguracionesEmpresa2["cedulaRepresentante"] = "cedulaRepresentante";
  ConfiguracionesEmpresa2["rucContador"] = "rucContador";
  ConfiguracionesEmpresa2["contribuyenteEspecial"] = "contribuyenteEspecial";
  ConfiguracionesEmpresa2["contribuyenteEspecialDesde"] = "contribuyenteEspecialDesde";
  ConfiguracionesEmpresa2["CompraInventarioSoloStockeable"] = "CompraInventarioSoloStockeable";
  ConfiguracionesEmpresa2["MaxLenghtCliente"] = "MaxLenghtCliente";
  ConfiguracionesEmpresa2["MaxLenghtProveedor"] = "MaxLenghtProveedor";
  ConfiguracionesEmpresa2["FacturaSeAnulaElMismoDia"] = "FacturaSeAnulaElMismoDia";
  ConfiguracionesEmpresa2["FacturacionMultibodega"] = "FacturacionMultibodega";
  ConfiguracionesEmpresa2["ObligadoContabilidad"] = "ObligadoContabilidad";
  ConfiguracionesEmpresa2["VenderArticulos"] = "VenderArticulos";
  ConfiguracionesEmpresa2["RangosCompartidos"] = "RangosCompartidos";
  ConfiguracionesEmpresa2["GenerarCodigosArticulos"] = "GenerarCodigosArticulos";
  ConfiguracionesEmpresa2["facturacionIncluidoIVA"] = "facturacionIncluidoIVA";
  ConfiguracionesEmpresa2["porcentajeIVA"] = "porcentajeIVA";
  ConfiguracionesEmpresa2["FPPlanAcumulativo"] = "FPPlanAcumulativo";
  ConfiguracionesEmpresa2["ConsumidorFinalPorDefecto"] = "ConsumidorFinalPorDefecto";
  ConfiguracionesEmpresa2["LetrasCuantosPagos"] = "LetrasCuantosPagos";
  ConfiguracionesEmpresa2["LetrasIntervaloDias"] = "LetrasIntervaloDias";
  ConfiguracionesEmpresa2["LetrasParametrosModificables"] = "LetrasParametrosModificables";
  ConfiguracionesEmpresa2["utilizarFormasDePagoPorBodega"] = "utilizarFormasDePagoPorBodega";
  ConfiguracionesEmpresa2["LetrasMaximoCuentosPagos"] = "LetrasMaximoCuentosPagos";
  ConfiguracionesEmpresa2["InteresPorLetras"] = "InteresPorLetras";
  ConfiguracionesEmpresa2["PagarCompletoCXC"] = "PagarCompletoCXC";
  ConfiguracionesEmpresa2["DecimalesEnInventario"] = "DecimalesEnInventario";
  ConfiguracionesEmpresa2["intentarGuardarCredito"] = "intentarGuardarCredito";
  ConfiguracionesEmpresa2["pvpCliente"] = "pvpCliente";
  ConfiguracionesEmpresa2["DescuentoCatalogo"] = "DescuentoCatalogo";
  ConfiguracionesEmpresa2["mostrarColores"] = "mostrarColores";
  ConfiguracionesEmpresa2["coincidir_bodega_rango_con_bodega_pc"] = "coincidir_bodega_rango_con_bodega_pc";
  ConfiguracionesEmpresa2["mostrarPorcentajeUtilidadVenta"] = "mostrarPorcentajeUtilidadVenta";
  ConfiguracionesEmpresa2["impedirAnularFacturaCerrada"] = "impedirAnularFacturaCerrada";
  ConfiguracionesEmpresa2["unificar_secuencias_comprobantes_egreso_cxp_contabilidad"] = "unificar_secuencias_comprobantes_egreso_cxp_contabilidad";
  ConfiguracionesEmpresa2["generar_1_comprobante_egreso_por_cada_compra"] = "generar_1_comprobante_egreso_por_cada_compra";
  ConfiguracionesEmpresa2["generar_1_comprobante_ingreso_por_cada_factura"] = "generar_1_comprobante_ingreso_por_cada_factura";
  ConfiguracionesEmpresa2["mostrar_calculadora_de_efectivo_recaudado_en_cierre"] = "mostrar_calculadora_de_efectivo_recaudado_en_cierre";
  ConfiguracionesEmpresa2["caracter_separacion_plan_cuentas"] = "caracter_separacion_plan_cuentas";
  ConfiguracionesEmpresa2["descuento_ventas_efectivo"] = "descuento_ventas_efectivo";
  ConfiguracionesEmpresa2["nivel_maximo_plan_cuentas"] = "nivel_maximo_plan_cuentas";
  ConfiguracionesEmpresa2["agregar_observacion_a_glosa_asiento"] = "agregar_observacion_a_glosa_asiento";
  ConfiguracionesEmpresa2["pedir_lote_en_proforma"] = "pedir_lote_en_proforma";
  ConfiguracionesEmpresa2["siempre_requerir_confirmacion_en_transferencias"] = "siempre_requerir_confirmacion_en_transferencias";
  ConfiguracionesEmpresa2["cuenta_contable_credito_ventas_modificable_usuario"] = "cuenta_contable_credito_ventas_modificable_usuario";
  ConfiguracionesEmpresa2["utilizar_lotes_como_IMEI"] = "utilizar_lotes_como_IMEI";
  ConfiguracionesEmpresa2["clave_firma_electronica"] = "clave_firma_electronica";
  ConfiguracionesEmpresa2["correo_servidor"] = "correo_servidor";
  ConfiguracionesEmpresa2["correo_usuario"] = "correo_usuario";
  ConfiguracionesEmpresa2["correo_contrase\xF1a"] = "correo_contrase\xF1a";
  ConfiguracionesEmpresa2["correo_puerto"] = "correo_puerto";
  ConfiguracionesEmpresa2["correo_ssl"] = "correo_ssl";
  ConfiguracionesEmpresa2["correo_remitente"] = "correo_remitente";
  ConfiguracionesEmpresa2["efact_ambiente"] = "efact_ambiente";
  ConfiguracionesEmpresa2["efact_contrase\xF1a_firma"] = "efact_contrase\xF1a_firma";
  ConfiguracionesEmpresa2["correo_autorizacion_cxp_calendario"] = "correo_autorizacion_cxp_calendario";
  ConfiguracionesEmpresa2["limite_resultados_busqueda_articulos"] = "limite_resultados_busqueda_articulos";
  ConfiguracionesEmpresa2["limite_resultados_busqueda_clientes"] = "limite_resultados_busqueda_clientes";
  ConfiguracionesEmpresa2["reservar_numero_de_factura_cuando_guarda_como_proforma"] = "reservar_numero_de_factura_cuando_guarda_como_proforma";
  ConfiguracionesEmpresa2["comprobante_ingreso_secuenciales_por_bodega"] = "comprobante_ingreso_secuenciales_por_bodega";
  ConfiguracionesEmpresa2["efact_web_descargas"] = "efact_web_descargas";
  ConfiguracionesEmpresa2["efact_exigir_correo_clientes"] = "efact_exigir_correo_clientes";
  ConfiguracionesEmpresa2["vendedor_en_detalle_habilitado"] = "vendedor_en_detalle_habilitado";
  ConfiguracionesEmpresa2["asignar_valor_conductor_por_guia"] = "asignar_valor_conductor_por_guia";
  ConfiguracionesEmpresa2["especificar_bodegas_por_usuario_en_facturacion"] = "especificar_bodegas_por_usuario_en_facturacion";
  ConfiguracionesEmpresa2["columnas_escondidas_en_busqueda_articulos"] = "columnas_escondidas_en_busqueda_articulos";
  ConfiguracionesEmpresa2["calculo_invertido"] = "calculo_invertido";
  ConfiguracionesEmpresa2["utilizar_cobradores_y_recibos"] = "utilizar_cobradores_y_recibos";
  ConfiguracionesEmpresa2["bloquear_venta_si_tiene_un_documento_con_x_dias_vencidos"] = "bloquear_venta_si_tiene_un_documento_con_x_dias_vencidos";
  ConfiguracionesEmpresa2["asignar_valor_vehiculo_por_guia"] = "asignar_valor_vehiculo_por_guia";
  ConfiguracionesEmpresa2["si_precio_es_0_consultar_ventas_anteriores"] = "si_precio_es_0_consultar_ventas_anteriores";
  ConfiguracionesEmpresa2["dias_aceptar_devolucion"] = "dias_aceptar_devolucion";
  ConfiguracionesEmpresa2["destinatario_orden_pedido"] = "destinatario_orden_pedido";
  ConfiguracionesEmpresa2["exigir_recibo_y_cobrador"] = "exigir_recibo_y_cobrador";
  ConfiguracionesEmpresa2["URI"] = "URI";
  ConfiguracionesEmpresa2["URI_SERVIDOR"] = "URI_SERVIDOR";
  ConfiguracionesEmpresa2["detalle_general_en_guias"] = "detalle_general_en_guias";
  ConfiguracionesEmpresa2["dias_plazo_predeterminado"] = "dias_plazo_predeterminado";
  ConfiguracionesEmpresa2["monto_credito_predeterminado"] = "monto_credito_predeterminado";
  ConfiguracionesEmpresa2["representanteLegal"] = "representanteLegal";
  ConfiguracionesEmpresa2["contador"] = "contador";
  ConfiguracionesEmpresa2["descripcion_general_guias"] = "descripcion_general_guias";
  ConfiguracionesEmpresa2["generar_orden_venta_servicios_con_Insumos"] = "generar_orden_venta_servicios_con_Insumos";
  ConfiguracionesEmpresa2["personalizar_cuentas_credito_y_anticipo_clientes"] = "personalizar_cuentas_credito_y_anticipo_clientes";
  ConfiguracionesEmpresa2["personalizar_cuentas_credito_y_anticipo_proveedores"] = "personalizar_cuentas_credito_y_anticipo_proveedores";
  ConfiguracionesEmpresa2["justificar_lotes_facturacion_durante_el_despacho"] = "justificar_lotes_facturacion_durante_el_despacho";
  ConfiguracionesEmpresa2["modificar_insumos_en_ventas"] = "modificar_insumos_en_ventas";
  ConfiguracionesEmpresa2["cuando_el_precio_de_compra_sube_solicita_autorizacion"] = "cuando_el_precio_de_compra_sube_solicita_autorizacion";
  ConfiguracionesEmpresa2["exigir_datos_de_tarjeta_de_credito"] = "exigir_datos_de_tarjeta_de_credito";
  ConfiguracionesEmpresa2["permitir_facturar_articulos_repetidos"] = "permitir_facturar_articulos_repetidos";
  ConfiguracionesEmpresa2["LS_SSRS"] = "LS_SSRS";
  ConfiguracionesEmpresa2["url_reportes_pcgn"] = "url_reportes_pcgn";
  ConfiguracionesEmpresa2["exigir_justificacion_para_anular"] = "exigir_justificacion_para_anular";
  ConfiguracionesEmpresa2["minimo_caracteres_justificar_anulacion"] = "minimo_caracteres_justificar_anulacion";
  ConfiguracionesEmpresa2["ver_codigo_plantilla_en_busqueda_articulos"] = "ver_codigo_plantilla_en_busqueda_articulos";
  ConfiguracionesEmpresa2["tabla_activa_retenciones_ir"] = "tabla_activa_retenciones_ir";
  ConfiguracionesEmpresa2["permitir_que_la_bodega_del_ajuste_de_egreso_sea_solo_para_centro_costos_y_no_inventario"] = "permitir_que_la_bodega_del_ajuste_de_egreso_sea_solo_para_centro_costos_y_no_inventario";
  ConfiguracionesEmpresa2["considerar_iva_en_compras_como_parte_del_gasto_o_costo"] = "considerar_iva_en_compras_como_parte_del_gasto_o_costo";
  ConfiguracionesEmpresa2["incluir_ventas_a_credito_en_cierre_de_caja"] = "incluir_ventas_a_credito_en_cierre_de_caja";
  ConfiguracionesEmpresa2["lineas_proforma_igual_factura"] = "lineas_proforma_igual_factura";
  ConfiguracionesEmpresa2["conexion_empresa_relacionado"] = "conexion_empresa_relacionado";
  ConfiguracionesEmpresa2["ruc_relacionado"] = "ruc_relacionado";
  ConfiguracionesEmpresa2["codigo_empresa_dinardap"] = "codigo_empresa_dinardap";
  ConfiguracionesEmpresa2["contabilizar_ventas_segun_el_centro_costos_del_detalle"] = "contabilizar_ventas_segun_el_centro_costos_del_detalle";
  ConfiguracionesEmpresa2["pagos_en_letras"] = "pagos_en_letras";
  ConfiguracionesEmpresa2["logistica_generar_una_guia_por_cada_factura"] = "logistica.generar_una_guia_por_cada_factura";
  ConfiguracionesEmpresa2["utilizar_rangos_electronicos_factura"] = "utilizar_rangos_electronicos_factura";
  ConfiguracionesEmpresa2["utilizar_rangos_electronicos_nota_credito"] = "utilizar_rangos_electronicos_nota_credito";
  ConfiguracionesEmpresa2["utilizar_rangos_electronicos_nota_debito"] = "utilizar_rangos_electronicos_nota_debito";
  ConfiguracionesEmpresa2["utilizar_rangos_electronicos_retencion"] = "utilizar_rangos_electronicos_retencion";
  ConfiguracionesEmpresa2["logistica_generar_una_factura_aparte_para_el_seguro"] = "logistica.generar_una_factura_aparte_para_el_seguro";
  ConfiguracionesEmpresa2["logistica_utilizar_reserva_de_guias_por_cliente"] = "logistica.utilizar_reserva_de_guias_por_cliente";
  ConfiguracionesEmpresa2["logistica_exigir_guia_remision_en_guias"] = "logistica.exigir_guia_remision_en_guias";
  ConfiguracionesEmpresa2["logistica_exigir_telefono_clientes"] = "logistica.exigir_telefono_clientes";
  ConfiguracionesEmpresa2["logistica_seguro_siempre_va_pagado"] = "logistica.seguro_siempre_va_pagado";
  ConfiguracionesEmpresa2["url_imagenes"] = "url_imagenes";
  ConfiguracionesEmpresa2["ruta_imagenes"] = "ruta_imagenes";
  ConfiguracionesEmpresa2["generar_numero_secuencial_para_compras_de_inventario"] = "generar_numero_secuencial_para_compras_de_inventario";
  ConfiguracionesEmpresa2["logistica_fletes_al_cobro_se_cobran_con_efectivo_de_origen"] = "logistica.fletes_al_cobro_se_cobran_con_efectivo_de_origen";
  ConfiguracionesEmpresa2["logistica_lista_de_precios_de_la_empresa_por_defecto"] = "logistica.lista_de_precios_de_la_empresa_por_defecto";
  ConfiguracionesEmpresa2["logistica_tipo_entrega_por_defecto"] = "logistica.tipo_entrega_por_defecto";
  ConfiguracionesEmpresa2["logistica_exigir_vehiculo_en_guias"] = "logistica.exigir_vehiculo_en_guias";
  ConfiguracionesEmpresa2["compra_de_inventario_debe_originarse_en_orden_de_compra"] = "compra_de_inventario_debe_originarse_en_orden_de_compra";
  ConfiguracionesEmpresa2["exigir_un_operador_distinto_en_cada_factura"] = "exigir_un_operador_distinto_en_cada_factura";
  ConfiguracionesEmpresa2["exigir_vendedor_en_detalle_factura"] = "exigir_vendedor_en_detalle_factura";
  ConfiguracionesEmpresa2["avanzar_la_secuencia_despues_de_anular_en_configuracion_documentos_anulados"] = "avanzar_la_secuencia_despues_de_anular_en_configuracion_documentos_anulados";
  ConfiguracionesEmpresa2["preguntar_antes_de_cerrar_si_hay_ventanas_abiertas"] = "preguntar_antes_de_cerrar_si_hay_ventanas_abiertas";
  ConfiguracionesEmpresa2["precios_cambiados_por_iva"] = "precios_cambiados_por_iva";
  ConfiguracionesEmpresa2["pasar_por_alto_validacion_iva_junio_2016"] = "pasar_por_alto_validacion_iva_junio_2016";
  ConfiguracionesEmpresa2["tama\xF1o_letra_busqueda_articulos"] = "tama\xF1o_letra_busqueda_articulos";
  ConfiguracionesEmpresa2["efact_imprimir_vendedor"] = "efact_imprimir_vendedor";
  ConfiguracionesEmpresa2["efact_imprimir_cupones"] = "efact_imprimir_cupones";
  ConfiguracionesEmpresa2["efact_imprimir_descuento_lineal"] = "efact_imprimir_descuento_lineal";
  ConfiguracionesEmpresa2["efact_imprimir_condensado"] = "efact_imprimir_condensado";
  ConfiguracionesEmpresa2["efact_imprimir_descripcion_larga"] = "efact_imprimir_descripcion_larga";
  ConfiguracionesEmpresa2["maneja_tallas_y_colores"] = "maneja_tallas_y_colores";
  ConfiguracionesEmpresa2["dejar_pasar_ventas_por_debajo_costo_en_promociones"] = "dejar_pasar_ventas_por_debajo_costo_en_promociones";
  ConfiguracionesEmpresa2["imprimir_fecha_y_hora_impresion_ventas"] = "imprimir_fecha_y_hora_impresion_ventas";
  ConfiguracionesEmpresa2["determinar_lista_de_precios_segun_la_cantidad_vendida"] = "determinar_lista_de_precios_segun_la_cantidad_vendida";
  ConfiguracionesEmpresa2["transferencia_secuenciales_por_bodega"] = "transferencia_secuenciales_por_bodega";
  ConfiguracionesEmpresa2["ajustes_secuenciales_por_bodega"] = "ajustes_secuenciales_por_bodega";
  ConfiguracionesEmpresa2["porcentaje_descuento_factura_mitad_precio"] = "porcentaje_descuento_factura_mitad_precio";
  ConfiguracionesEmpresa2["mostrar_datos_ultima_compra_en_compra_inventario"] = "mostrar_datos_ultima_compra_en_compra_inventario";
  ConfiguracionesEmpresa2["incluir_compras_en_cierre_de_caja"] = "incluir_compras_en_cierre_de_caja";
  ConfiguracionesEmpresa2["integrarse_con_sisint_nom"] = "integrarse_con_sisint_nom";
  ConfiguracionesEmpresa2["impedir_guardar_asiento_con_bodegas_distintas"] = "impedir_guardar_asiento_con_bodegas_distintas";
  ConfiguracionesEmpresa2["comprobante_ingreso_imprimir_directo_pos"] = "comprobante_ingreso_imprimir_directo_pos";
  ConfiguracionesEmpresa2["anexar_ventas_por_lineas_cierre_caja"] = "anexar_ventas_por_lineas_cierre_caja";
  ConfiguracionesEmpresa2["utilizar_precio_6_si_es_menor_que_precio_por_defecto"] = "utilizar_precio_6_si_es_menor_que_precio_por_defecto";
  ConfiguracionesEmpresa2["exigir_cuenta_credito_personalizada_en_proveedores"] = "exigir_cuenta_credito_personalizada_en_proveedores";
  ConfiguracionesEmpresa2["mostrar_oferta_en_facturas"] = "mostrar_oferta_en_facturas";
  ConfiguracionesEmpresa2["exigir_justificacion_para_reimprimir"] = "exigir_justificacion_para_reimprimir";
  ConfiguracionesEmpresa2["dejar_pasar_ventas_por_debajo_costo_en_ofertas"] = "dejar_pasar_ventas_por_debajo_costo_en_ofertas";
  ConfiguracionesEmpresa2["usar_cuenta_articulo_cuando_hay_1_detalle_venta_diferida"] = "usar_cuenta_articulo_cuando_hay_1_detalle_venta_diferida";
  ConfiguracionesEmpresa2["exigir_factura_con_datos_si_paga_con_tarjeta"] = "exigir_factura_con_datos_si_paga_con_tarjeta";
  ConfiguracionesEmpresa2["PermitirChequesProveedorRepetidos"] = "PermitirChequesProveedorRepetidos";
  ConfiguracionesEmpresa2["PermitirChequesClienteRepetidos"] = "PermitirChequesClienteRepetidos";
  ConfiguracionesEmpresa2["usar_fichas"] = "usar_fichas";
  ConfiguracionesEmpresa2["usar_factura_beta"] = "usar_factura_beta";
  ConfiguracionesEmpresa2["permitir_entrada_credito_venta_diferida"] = "permitir_entrada_credito_venta_diferida";
  ConfiguracionesEmpresa2["registrar_una_liquidacion_distinta_por_cada_voucher"] = "registrar_una_liquidacion_distinta_por_cada_voucher";
  ConfiguracionesEmpresa2["guardar_ado_asientos"] = "guardar_ado_asientos";
  ConfiguracionesEmpresa2["exigir_fecha_caducidad_compras"] = "exigir_fecha_caducidad_compras";
  ConfiguracionesEmpresa2["mostrar_vuelo_en_facturas"] = "mostrar_vuelo_en_facturas";
  ConfiguracionesEmpresa2["lotes_por_bodega"] = "lotes_por_bodega";
  ConfiguracionesEmpresa2["impedir_guardar_si_no_usan_lotes_mas_proximos_a_caducar"] = "impedir_guardar_si_no_usan_lotes_mas_proximos_a_caducar";
  ConfiguracionesEmpresa2["imprimir_lotes_con_fecha_caducidad"] = "imprimir_lotes_con_fecha_caducidad";
  ConfiguracionesEmpresa2["utilizar_fecha_entrega_como_retiro_programado_ventas_anticipadas"] = "utilizar_fecha_entrega_como_retiro_programado_ventas_anticipadas";
  ConfiguracionesEmpresa2["historia_clinica_egreso_reimpresion_facturas"] = "historia_clinica_egreso_reimpresion_facturas";
  ConfiguracionesEmpresa2["exigir_monto_credito_para_guardar_cheque_en_ventas"] = "exigir_monto_credito_para_guardar_cheque_en_ventas";
  ConfiguracionesEmpresa2["exigir_correo_electronico_a_clientes_con_ruc"] = "exigir_correo_electronico_a_clientes_con_ruc";
  ConfiguracionesEmpresa2["cuenta_unica_para_credito_comprobantes_venta"] = "cuenta_unica_para_credito_comprobantes_venta";
  ConfiguracionesEmpresa2["correo_bcc"] = "correo_bcc";
  ConfiguracionesEmpresa2["correo_suplantar_destinatario"] = "correo_suplantar_destinatario";
  ConfiguracionesEmpresa2["exigir_orden_trabajo_para_manifiestos"] = "exigir_orden_trabajo_para_manifiestos";
  ConfiguracionesEmpresa2["intentar_cruzar_notas_credito_proveedores"] = "intentar_cruzar_notas_credito_proveedores";
  ConfiguracionesEmpresa2["exigir_ciudad_y_provincia_a_clientes_dinardap"] = "exigir_ciudad_y_provincia_a_clientes_dinardap";
  ConfiguracionesEmpresa2["ambientes_contables"] = "ambientes_contables";
  ConfiguracionesEmpresa2["siacad_trabaja_sobre_matriculas"] = "siacad_trabaja_sobre_matriculas";
  ConfiguracionesEmpresa2["logistica_cuota_vehiculo_alerta"] = "logistica_cuota_vehiculo_alerta";
  ConfiguracionesEmpresa2["imprimir_insumos_que_componen_receta"] = "imprimir_insumos_que_componen_receta";
  ConfiguracionesEmpresa2["incluir_todo_el_descuento_en_la_primera_factura_para_venta_diferida"] = "incluir_todo_el_descuento_en_la_primera_factura_para_venta_diferida";
  ConfiguracionesEmpresa2["imprimir_datos_empresa_en_comprobante_venta"] = "imprimir_datos_empresa_en_comprobante_venta";
  ConfiguracionesEmpresa2["numero_proforma_editable"] = "numero_proforma_editable";
  ConfiguracionesEmpresa2["conservar_todas_las_proformas_convertidas"] = "conservar_todas_las_proformas_convertidas";
  ConfiguracionesEmpresa2["conservar_fecha_proforma_al_convertir"] = "conservar_fecha_proforma_al_convertir";
  ConfiguracionesEmpresa2["utilizar_mayor_ligero"] = "utilizar_mayor_ligero";
  ConfiguracionesEmpresa2["utilizar_guias_transporte"] = "utilizar_guias_transporte";
  ConfiguracionesEmpresa2["imprimir_no_se_aceptan_devoluciones"] = "imprimir_no_se_aceptan_devoluciones";
  ConfiguracionesEmpresa2["utilizar_rubros_pagare"] = "utilizar_rubros_pagare";
  ConfiguracionesEmpresa2["etiquetas_zebra_impresora"] = "etiquetas_zebra_impresora";
  ConfiguracionesEmpresa2["etiquetas_zebra_modelo"] = "etiquetas_zebra_modelo";
  ConfiguracionesEmpresa2["mostrar_comision_completa_descuento"] = "mostrar_comision_completa_descuento";
  ConfiguracionesEmpresa2["mostrar_recibe_medidas"] = "mostrar_recibe_medidas";
  ConfiguracionesEmpresa2["mostrar_expectativa_ventas"] = "mostrar_expectativa_ventas";
  ConfiguracionesEmpresa2["impedir_numeros_banco_repetidos"] = "impedir_numeros_banco_repetidos";
  ConfiguracionesEmpresa2["envio_masivo_estado_cuenta_clientes_preferencia_correo"] = "envio_masivo_estado_cuenta_clientes_preferencia_correo";
  ConfiguracionesEmpresa2["face_api_person_group_id"] = "face_api_person_group_id";
  ConfiguracionesEmpresa2["face_api_person_group_name"] = "face_api_person_group_name";
  ConfiguracionesEmpresa2["pcgerentenode_url_api"] = "pcgerentenode_url_api";
  ConfiguracionesEmpresa2["pedir_forma_pago_al_guardar_la_factura"] = "pedir_forma_pago_al_guardar_la_factura";
  ConfiguracionesEmpresa2["valor_comision_senae"] = "valor_comision_senae";
  ConfiguracionesEmpresa2["envio_masivo_estado_cuenta_clientes_exigir_pago_vencido"] = "envio_masivo_estado_cuenta_clientes_exigir_pago_vencido";
  ConfiguracionesEmpresa2["url_imagen_logo_empresa"] = "url_imagen_logo_empresa";
  ConfiguracionesEmpresa2["mostrar_importaciones_en_transito_en_consultar_existencias_articulos"] = "mostrar_importaciones_en_transito_en_consultar_existencias_articulos";
  ConfiguracionesEmpresa2["app_mostrar_solo_clientes_que_pertenecen_a_vendedor"] = "app_mostrar_solo_clientes_que_pertenecen_a_vendedor";
  ConfiguracionesEmpresa2["app_mostrar_existencia_general_en_ventas"] = "app_mostrar_existencia_general_en_ventas";
  ConfiguracionesEmpresa2["permitir_proveedores_distintos_factura_y_cartera"] = "permitir_proveedores_distintos_factura_y_cartera";
  ConfiguracionesEmpresa2["ocultar_campos_busqueda_guias"] = "ocultar_campos_busqueda_guias";
  ConfiguracionesEmpresa2["utilizar_guias_aereas"] = "utilizar_guias_aereas";
  ConfiguracionesEmpresa2["permitir_precio_0"] = "permitir_precio_0";
  ConfiguracionesEmpresa2["usar_regalos_Peluquero"] = "usar_regalos_Peluquero";
  ConfiguracionesEmpresa2["pagos_venta_diferida_detalle_propio_calculado"] = "pagos_venta_diferida_detalle_propio_calculado";
  ConfiguracionesEmpresa2["PermitirAjustesRepetidos"] = "PermitirAjustesRepetidos";
  ConfiguracionesEmpresa2["marcaciones_en_nomina"] = "marcaciones_en_nomina";
  ConfiguracionesEmpresa2["mc_costo_ultimo_fecha_correccion"] = "mc_costo_ultimo_fecha_correccion";
  ConfiguracionesEmpresa2["mostrar_bodegas_existencia_0_en_consulta_existencia"] = "mostrar_bodegas_existencia_0_en_consulta_existencia";
  ConfiguracionesEmpresa2["efact_imprimir_enviar_retenciones_a"] = "efact_imprimir_enviar_retenciones_a";
  ConfiguracionesEmpresa2["efact_imprimir_telefono_empresa"] = "efact_imprimir_telefono_empresa";
  ConfiguracionesEmpresa2["efact_imprimir_salida_la_mercaderia_no_se_aceptan_devoluciones"] = "efact_imprimir_salida_la_mercaderia_no_se_aceptan_devoluciones";
  ConfiguracionesEmpresa2["efact_imprimir_observacion"] = "efact_imprimir_observacion";
  ConfiguracionesEmpresa2["efact_imprimir_entregue_conforme_recibi_conforme"] = "efact_imprimir_entregue_conforme_recibi_conforme";
  ConfiguracionesEmpresa2["efact_imprimir_usuario_y_fecha_creacion"] = "efact_imprimir_usuario_y_fecha_creacion";
  ConfiguracionesEmpresa2["correo_recibir_retenciones_clientes"] = "correo_recibir_retenciones_clientes";
  ConfiguracionesEmpresa2["permitir_articulos_sin_existencia_en_pedido_interno"] = "permitir_articulos_sin_existencia_en_pedido_interno";
  ConfiguracionesEmpresa2["bloquear_bodega_destino_en_pedido_interno"] = "bloquear_bodega_destino_en_pedido_interno";
  ConfiguracionesEmpresa2["contribuyente_regimen_microempresas"] = "contribuyente_regimen_microempresas";
  ConfiguracionesEmpresa2["azure_blob_storage_container"] = "azure_blob_storage_container";
  ConfiguracionesEmpresa2["permitir_visualizar_4_decimales_costo_kardex"] = "permitir_visualizar_4_decimales_costo_kardex";
  ConfiguracionesEmpresa2["ciudad_cheque"] = "ciudad_cheque";
  ConfiguracionesEmpresa2["imprimir_cheques_con_rdlc"] = "imprimir_cheques_con_rdlc";
  ConfiguracionesEmpresa2["es_agente_retencion_microempresa"] = "es_agente_retencion_microempresa";
  ConfiguracionesEmpresa2["agente_retencion_microempresa_resolucion"] = "agente_retencion_microempresa_resolucion";
  ConfiguracionesEmpresa2["ventas_orden_impresion"] = "ventas_orden_impresion";
  ConfiguracionesEmpresa2["orden_pedido_descuento_libre"] = "orden_pedido_descuento_libre";
  ConfiguracionesEmpresa2["cpc_sector_publico"] = "cpc_sector_publico";
  ConfiguracionesEmpresa2["retenciones_en_0_numeradas"] = "retenciones_en_0_numeradas";
  ConfiguracionesEmpresa2["imprimir_factura_con_rdlc"] = "imprimir_factura_con_rdlc";
  ConfiguracionesEmpresa2["efact_offline"] = "efact_offline";
  ConfiguracionesEmpresa2["generar_asiento_nota_credito_anulacion_electronica"] = "generar_asiento_nota_credito_anulacion_electronica";
  ConfiguracionesEmpresa2["armar_receta_revisado_por"] = "armar_receta_revisado_por";
  ConfiguracionesEmpresa2["armar_receta_recibido_por"] = "armar_receta_recibido_por";
  ConfiguracionesEmpresa2["abrir_caja_monedas_con_pagos_cxc"] = "abrir_caja_monedas_con_pagos_cxc";
  ConfiguracionesEmpresa2["mostrar_ubicacion_de_articulos_en_busqueda"] = "mostrar_ubicacion_de_articulos_en_busqueda";
  ConfiguracionesEmpresa2["mostrar_ubicacion_de_articulos_en_ventas"] = "mostrar_ubicacion_de_articulos_en_ventas";
  ConfiguracionesEmpresa2["efact_exigir_correo"] = "efact_exigir_correo";
  ConfiguracionesEmpresa2["utilizar_codigo_barras_para_iniciar_sesion_operadores"] = "utilizar_codigo_barras_para_iniciar_sesion_operadores";
  ConfiguracionesEmpresa2["permitir_varias_notas_de_credito_y_debito_cxc_a_la_misma_factura"] = "permitir_varias_notas_de_credito_y_debito_cxc_a_la_misma_factura";
  ConfiguracionesEmpresa2["permitir_varias_notas_de_credito_y_debito_cxp_a_la_misma_factura"] = "permitir_varias_notas_de_credito_y_debito_cxp_a_la_misma_factura";
  ConfiguracionesEmpresa2["permitir_clientes_distintos_factura_y_cartera"] = "permitir_clientes_distintos_factura_y_cartera";
  ConfiguracionesEmpresa2["exigir_ecovalor"] = "exigir_ecovalor";
  ConfiguracionesEmpresa2["formato_impresion_comprobante_ingreso"] = "formato_impresion_comprobante_ingreso";
  ConfiguracionesEmpresa2["mostrar_tipo_iva"] = "mostrar_tipo_iva";
  ConfiguracionesEmpresa2["ats_forma_pago_ventas_default"] = "ats_forma_pago_ventas_default";
  ConfiguracionesEmpresa2["llenar_sustento_tributario_y_tipo_compra_a_partir_de_ultima_compra"] = "llenar_sustento_tributario_y_tipo_compra_a_partir_de_ultima_compra";
  ConfiguracionesEmpresa2["correo_configuracion"] = "correo_configuracion";
  ConfiguracionesEmpresa2["correo_api"] = "correo_api";
  ConfiguracionesEmpresa2["exigir_retencion_al_guardar_la_compra"] = "exigir_retencion_al_guardar_la_compra";
  ConfiguracionesEmpresa2["puerto_default_balanza"] = "puerto_default_balanza";
  ConfiguracionesEmpresa2["Ruta_Inbox_Img_Guias"] = "Ruta_Inbox_Img_Guias";
  ConfiguracionesEmpresa2["Ruta_Persistencia_Img_Guias"] = "Ruta_Persistencia_Img_Guias";
  ConfiguracionesEmpresa2["Ruta_Http_Img_Guias"] = "Ruta_Http_Img_Guias";
  ConfiguracionesEmpresa2["correo_remitente_SAT"] = "correo_remitente_SAT";
  ConfiguracionesEmpresa2["codigo_cliente_empresa"] = "codigo_cliente_empresa";
  ConfiguracionesEmpresa2["conciliacion_no_considerado_cambiar_signo"] = "conciliacion_no_considerado_cambiar_signo";
  ConfiguracionesEmpresa2["exigir_chasis_guias_transporte"] = "exigir_chasis_guias_transporte";
  ConfiguracionesEmpresa2["descripcion_modificable_compras"] = "descripcion_modificable_compras";
  ConfiguracionesEmpresa2["retenciones_asumidas_numeradas_9"] = "retenciones_asumidas_numeradas_9";
  ConfiguracionesEmpresa2["exigir_justificacion_para_anular_compra"] = "exigir_justificacion_para_anular_compra";
  ConfiguracionesEmpresa2["minimo_caracteres_justificar_anulacion_compra"] = "minimo_caracteres_justificar_anulacion_compra";
  ConfiguracionesEmpresa2["exigir_justificacion_para_anular_compb_egr"] = "exigir_justificacion_para_anular_compb_egr";
  ConfiguracionesEmpresa2["minimo_caracteres_justificar_anulacion_compb_egr"] = "minimo_caracteres_justificar_anulacion_compb_egr";
  ConfiguracionesEmpresa2["exigir_justificacion_para_anular_compra_nd_nc"] = "exigir_justificacion_para_anular_compra_nd_nc";
  ConfiguracionesEmpresa2["minimo_caracteres_justificar_anulacion_compra_nd_nc"] = "minimo_caracteres_justificar_anulacion_compra_nd_nc";
  ConfiguracionesEmpresa2["exigir_justificacion_para_anular_compra_ext"] = "exigir_justificacion_para_anular_compra_ext";
  ConfiguracionesEmpresa2["minimo_caracteres_justificar_anulacion_compra_ext"] = "minimo_caracteres_justificar_anulacion_compra_ext";
  ConfiguracionesEmpresa2["exigir_justificacion_para_anular_compra_ret"] = "exigir_justificacion_para_anular_compra_ret";
  ConfiguracionesEmpresa2["minimo_caracteres_justificar_anulacion_compra_ret"] = "minimo_caracteres_justificar_anulacion_compra_ret";
  ConfiguracionesEmpresa2["exigir_justificacion_para_anular_compb_ing"] = "exigir_justificacion_para_anular_compb_ing";
  ConfiguracionesEmpresa2["minimo_caracteres_justificar_anulacion_compb_ing"] = "minimo_caracteres_justificar_anulacion_compb_ing";
  ConfiguracionesEmpresa2["exigir_justificacion_para_anular_cruce_cxc_cxp"] = "exigir_justificacion_para_anular_cruce_cxc_cxp";
  ConfiguracionesEmpresa2["minimo_caracteres_justificar_anulacion_cruce_cxc_cxp"] = "minimo_caracteres_justificar_anulacion_cruce_cxc_cxp";
  ConfiguracionesEmpresa2["exigir_justificacion_para_anular_nomina"] = "exigir_justificacion_para_anular_nomina";
  ConfiguracionesEmpresa2["minimo_caracteres_justificar_anulacion_nomina"] = "minimo_caracteres_justificar_anulacion_nomina";
  ConfiguracionesEmpresa2["exigir_justificacion_para_anular_importacion"] = "exigir_justificacion_para_anular_importacion";
  ConfiguracionesEmpresa2["minimo_caracteres_justificar_anulacion_importacion"] = "minimo_caracteres_justificar_anulacion_importacion";
  ConfiguracionesEmpresa2["exigir_justificacion_para_anular_transf_ajuste_ing_egr"] = "exigir_justificacion_para_anular_transf_ajuste_ing_egr";
  ConfiguracionesEmpresa2["minimo_caracteres_justificar_anulacion_transf_ajuste_ing_egr"] = "minimo_caracteres_justificar_anulacion_transf_ajuste_ing_egr";
  ConfiguracionesEmpresa2["exigir_justificacion_para_anular_venta_nd_nc"] = "exigir_justificacion_para_anular_venta_nd_nc";
  ConfiguracionesEmpresa2["minimo_caracteres_justificar_anulacion_venta_nd_nc"] = "minimo_caracteres_justificar_anulacion_venta_nd_nc";
  ConfiguracionesEmpresa2["permitir_visualizar_movimientos_anulados_kardex"] = "permitir_visualizar_movimientos_anulados_kardex";
  ConfiguracionesEmpresa2["permitir_registrar_transaccion_posterior"] = "permitir_registrar_transaccion_posterior";
  ConfiguracionesEmpresa2["puerto_ip_bascula"] = "puerto_ip_bascula";
  ConfiguracionesEmpresa2["puerto_red_bascula"] = "puerto_red_bascula";
  ConfiguracionesEmpresa2["habilitar_campos_peso_guia_bascula"] = "habilitar_campos_peso_guia_bascula";
  ConfiguracionesEmpresa2["especificar_bodega_pre_limpieza_piladora"] = "especificar_bodega_pre_limpieza_piladora";
  ConfiguracionesEmpresa2["bodegaPiladora"] = "bodegaPiladora";
  ConfiguracionesEmpresa2["respetar_bodega_piladora_pre_limpieza_explosion"] = "respetar_bodega_piladora_pre_limpieza_explosion";
  ConfiguracionesEmpresa2["imprimir_comprobante_venta_piladora"] = "imprimir_comprobante_venta_piladora";
  ConfiguracionesEmpresa2["visualizar_informacion_ventas_aprobar_orden_pedido"] = "visualizar_informacion_ventas_aprobar_orden_pedido";
  ConfiguracionesEmpresa2["visualizar_cliente_establecimiento"] = "visualizar_cliente_establecimiento";
  ConfiguracionesEmpresa2["frecuencia_envio_masivo_estado_cuenta_cliente"] = "frecuencia_envio_masivo_estado_cuenta_cliente";
  ConfiguracionesEmpresa2["directorio_archivos_IDEXX"] = "directorio_archivos_IDEXX";
  ConfiguracionesEmpresa2["leyenda_pie_correo_estado_cuenta_cliente_masivo"] = "leyenda_pie_correo_estado_cuenta_cliente_masivo";
  ConfiguracionesEmpresa2["usar_reproceso_inventario_sql"] = "usar_reproceso_inventario_sql";
  ConfiguracionesEmpresa2["envio_masivo_alerta_fin_consignacion_preferencia_correo"] = "envio_masivo_alerta_fin_consignacion_preferencia_correo";
  ConfiguracionesEmpresa2["leyenda_pie_correo_alerta_fin_consignacion"] = "leyenda_pie_correo_alerta_fin_consignacion";
  ConfiguracionesEmpresa2["app_excluir_cheques_en_cartera"] = "app_excluir_cheques_en_cartera";
  ConfiguracionesEmpresa2["url_pagina_web_empresa"] = "url_pagina_web_empresa";
  ConfiguracionesEmpresa2["app_metros_distancia_permitida_visita"] = "app_metros_distancia_permitida_visita";
  ConfiguracionesEmpresa2["exigir_forma_pago_efectivo_por_usuario"] = "exigir_forma_pago_efectivo_por_usuario";
  ConfiguracionesEmpresa2["logistica_entrega_maximo_numero_fotos"] = "logistica.entrega_maximo_numero_fotos";
  ConfiguracionesEmpresa2["logistica_entrega_minimo_numero_fotos"] = "logistica.entrega_minimo_numero_fotos";
  ConfiguracionesEmpresa2["username_servidor_api"] = "username_servidor_api";
  ConfiguracionesEmpresa2["password_servidor_api"] = "password_servidor_api";
  ConfiguracionesEmpresa2["app_ocultar_referencia_impresion_escpos"] = "app_ocultar_referencia_impresion_escpos";
  ConfiguracionesEmpresa2["app_ocultar_detalle_impresion_escpos"] = "app_ocultar_detalle_impresion_escpos";
  return ConfiguracionesEmpresa2;
}({});
var TiposVisita = /* @__PURE__ */ function(TiposVisita2) {
  TiposVisita2[TiposVisita2["PEDIDO"] = 1] = "PEDIDO";
  TiposVisita2[TiposVisita2["COBRANZA"] = 2] = "COBRANZA";
  TiposVisita2[TiposVisita2["GESTION_COBRANZA"] = 3] = "GESTION_COBRANZA";
  TiposVisita2[TiposVisita2["OTROS"] = 4] = "OTROS";
  return TiposVisita2;
}({});
var FormasPagoEspeciales = /* @__PURE__ */ function(FormasPagoEspeciales2) {
  FormasPagoEspeciales2["RetencionAsumida"] = "RETENCION ASUMIDA";
  return FormasPagoEspeciales2;
}({});
var MovimientoCabeceraObservacionesEspeciales = /* @__PURE__ */ function(MovimientoCabeceraObservacionesEspeciales2) {
  MovimientoCabeceraObservacionesEspeciales2["ComisionSenae"] = "COMISI\xD3N SENAE";
  return MovimientoCabeceraObservacionesEspeciales2;
}({});
var TiposPago = /* @__PURE__ */ function(TiposPago2) {
  TiposPago2[TiposPago2["EFECTIVO"] = 1] = "EFECTIVO";
  TiposPago2[TiposPago2["CHEQUE"] = 2] = "CHEQUE";
  TiposPago2[TiposPago2["TARJETA"] = 3] = "TARJETA";
  TiposPago2[TiposPago2["RETENCION"] = 4] = "RETENCION";
  TiposPago2[TiposPago2["TRANSFERENCIA"] = 5] = "TRANSFERENCIA";
  return TiposPago2;
}({});
var TiposFormaPago = /* @__PURE__ */ function(TiposFormaPago2) {
  TiposFormaPago2[TiposFormaPago2["CREDITO"] = 1] = "CREDITO";
  TiposFormaPago2[TiposFormaPago2["EFECTIVO"] = 2] = "EFECTIVO";
  TiposFormaPago2[TiposFormaPago2["CHEQUE_CXP"] = 3] = "CHEQUE_CXP";
  TiposFormaPago2[TiposFormaPago2["CHEQUE_CXC"] = 4] = "CHEQUE_CXC";
  TiposFormaPago2[TiposFormaPago2["TARJETA_CREDITO_DEBITO"] = 5] = "TARJETA_CREDITO_DEBITO";
  TiposFormaPago2[TiposFormaPago2["RETENCION_IR"] = 6] = "RETENCION_IR";
  TiposFormaPago2[TiposFormaPago2["RETENCION_IVA"] = 7] = "RETENCION_IVA";
  TiposFormaPago2[TiposFormaPago2["RETENCION_0"] = 8] = "RETENCION_0";
  TiposFormaPago2[TiposFormaPago2["DINERO_ELECTRONICO"] = 9] = "DINERO_ELECTRONICO";
  TiposFormaPago2[TiposFormaPago2["NOTA_CREDITO"] = 10] = "NOTA_CREDITO";
  TiposFormaPago2[TiposFormaPago2["PLAN_ACUMULATIVO"] = 11] = "PLAN_ACUMULATIVO";
  TiposFormaPago2[TiposFormaPago2["OTROS"] = 12] = "OTROS";
  TiposFormaPago2[TiposFormaPago2["ANTICIPO"] = 13] = "ANTICIPO";
  TiposFormaPago2[TiposFormaPago2["COMPROBANTE_DE_VENTA"] = 14] = "COMPROBANTE_DE_VENTA";
  TiposFormaPago2[TiposFormaPago2["SENAE"] = 15] = "SENAE";
  TiposFormaPago2[TiposFormaPago2["OTROS_INGRESOS_DEVOLUCION_DINERO"] = 15] = "OTROS_INGRESOS_DEVOLUCION_DINERO";
  return TiposFormaPago2;
}({});
var CuentasEnlace = /* @__PURE__ */ function(CuentasEnlace2) {
  CuentasEnlace2["ivaCompras"] = "ivaCompras";
  CuentasEnlace2["ivaVentas"] = "ivaVentas";
  CuentasEnlace2["descuentosVentas"] = "descuentosVentas";
  CuentasEnlace2["ajusteEgreso"] = "ajusteEgreso";
  CuentasEnlace2["ajusteIngreso"] = "ajusteIngreso";
  CuentasEnlace2["descuadre"] = "descuadre";
  CuentasEnlace2["ctaAnticiposCXC"] = "ctaAnticiposCXC";
  CuentasEnlace2["ctaAnticiposCXP"] = "ctaAnticiposCXP";
  CuentasEnlace2["CXC_IngresosInteres"] = "CXC_IngresosInteres";
  CuentasEnlace2["CXC_IngresosSeguro"] = "CXC_IngresosSeguro";
  CuentasEnlace2["CXC_IngresosOtros"] = "CXC_IngresosOtros";
  CuentasEnlace2["Diferencia_Cierre_Caja_Deposito"] = "Diferencia_Cierre_Caja_Deposito";
  CuentasEnlace2["NotasCredito_Pendientes_Por_Aprobar"] = "NotasCredito_Pendientes_Por_Aprobar";
  CuentasEnlace2["Ret_IVA_Presuntivo"] = "Ret_IVA_Presuntivo";
  CuentasEnlace2["Ret_IR_Presuntivo"] = "Ret_IR_Presuntivo";
  CuentasEnlace2["reembolsos"] = "reembolsos";
  CuentasEnlace2["reefinanciamientoCompras"] = "reefinanciamientoCompras";
  CuentasEnlace2["reefinanciamientoVentas"] = "reefinanciamientoVentas";
  CuentasEnlace2["CXCDiferida"] = "CXCDiferida";
  CuentasEnlace2["cargarTransportistas"] = "cargarTransportistas";
  CuentasEnlace2["provisionInventarioVentaAnticipada"] = "provisionInventarioVentaAnticipada";
  CuentasEnlace2["provisionCostoVentaAnticipada"] = "provisionCostoVentaAnticipada";
  CuentasEnlace2["financiamientoCompras"] = "financiamientoCompras";
  CuentasEnlace2["financiamientoVentas"] = "financiamientoVentas";
  CuentasEnlace2["ajusteRedondedoCentavos"] = "ajusteRedondedoCentavos";
  CuentasEnlace2["Guias_arroz_pendientes_por_liquidar"] = "Guias_arroz_pendientes_por_liquidar";
  CuentasEnlace2["merma_empaque"] = "merma_empaque";
  CuentasEnlace2["cxc_comprobante_venta"] = "cxc_comprobante_venta";
  CuentasEnlace2["IRBPNR"] = "IRBPNR";
  CuentasEnlace2["senae_cxp"] = "senae_cxp";
  CuentasEnlace2["senae_comisiones_pagadas"] = "senae_comisiones_pagadas";
  CuentasEnlace2["senae_comisiones_asumidas"] = "senae_comisiones_asumidas";
  CuentasEnlace2["descuento_comprobantes_venta"] = "descuento_comprobantes_venta";
  CuentasEnlace2["iceVentas"] = "iceVentas";
  return CuentasEnlace2;
}({});
var Notificaciones = /* @__PURE__ */ function(Notificaciones2) {
  Notificaciones2["SOLICITUD_CONVERSION_LOGISTICA"] = "Solicitud de conversi\xF3n desde Log\xEDstica";
  return Notificaciones2;
}({});
var TablasTransacciones = /* @__PURE__ */ function(TablasTransacciones2) {
  TablasTransacciones2[TablasTransacciones2["MC"] = 1] = "MC";
  TablasTransacciones2[TablasTransacciones2["IC"] = 2] = "IC";
  TablasTransacciones2[TablasTransacciones2["AC"] = 3] = "AC";
  return TablasTransacciones2;
}({});
var HTTP_STATUS = /* @__PURE__ */ function(HTTP_STATUS2) {
  HTTP_STATUS2[HTTP_STATUS2["OK"] = 200] = "OK";
  HTTP_STATUS2[HTTP_STATUS2["CREATED"] = 201] = "CREATED";
  HTTP_STATUS2[HTTP_STATUS2["ACCEPTED_AND_PROCESSING"] = 202] = "ACCEPTED_AND_PROCESSING";
  HTTP_STATUS2[HTTP_STATUS2["OK_WITHOUT_CONTENT"] = 204] = "OK_WITHOUT_CONTENT";
  HTTP_STATUS2[HTTP_STATUS2["BAD_REQUEST"] = 300] = "BAD_REQUEST";
  HTTP_STATUS2[HTTP_STATUS2["NOT_FOUND"] = 404] = "NOT_FOUND";
  HTTP_STATUS2[HTTP_STATUS2["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
  HTTP_STATUS2[HTTP_STATUS2["INTERNAL_SERVER_ERROR"] = 500] = "INTERNAL_SERVER_ERROR";
  return HTTP_STATUS2;
}({});
var ConstantesDocumentos = class {
};
__name(ConstantesDocumentos, "ConstantesDocumentos");
__publicField(ConstantesDocumentos, "DocumentosCXC", "1,3,12,22,25,21,31,34");
var Modulos = /* @__PURE__ */ function(Modulos2) {
  Modulos2[Modulos2["VENTAS"] = 1] = "VENTAS";
  Modulos2[Modulos2["CUENTAS_POR_COBRAR"] = 2] = "CUENTAS_POR_COBRAR";
  Modulos2[Modulos2["INVENTARIO"] = 3] = "INVENTARIO";
  Modulos2[Modulos2["CONTABILIDAD"] = 4] = "CONTABILIDAD";
  Modulos2[Modulos2["COMPRAS"] = 5] = "COMPRAS";
  Modulos2[Modulos2["CUENTAS_POR_PAGAR"] = 6] = "CUENTAS_POR_PAGAR";
  Modulos2[Modulos2["CONFIGURACION"] = 7] = "CONFIGURACION";
  Modulos2[Modulos2["SRI"] = 8] = "SRI";
  Modulos2[Modulos2["ROLES_Y_ATRIBUCIONES"] = 9] = "ROLES_Y_ATRIBUCIONES";
  Modulos2[Modulos2["BANCOS"] = 12] = "BANCOS";
  Modulos2[Modulos2["NOMINA"] = 13] = "NOMINA";
  Modulos2[Modulos2["IMPORTACIONES"] = 14] = "IMPORTACIONES";
  Modulos2[Modulos2["REPORTES"] = 18] = "REPORTES";
  Modulos2[Modulos2["DASHBOARD"] = 19] = "DASHBOARD";
  Modulos2[Modulos2["TALLER"] = 20] = "TALLER";
  Modulos2[Modulos2["RENTING"] = 21] = "RENTING";
  Modulos2[Modulos2["CAJA"] = 25] = "CAJA";
  Modulos2[Modulos2["LOGISTICA"] = 27] = "LOGISTICA";
  Modulos2[Modulos2["APP"] = 28] = "APP";
  Modulos2[Modulos2["PILADORA2"] = 29] = "PILADORA2";
  Modulos2[Modulos2["API"] = 30] = "API";
  return Modulos2;
}({});
var Permisos = /* @__PURE__ */ function(Permisos2) {
  Permisos2[Permisos2["Empleados"] = 1] = "Empleados";
  Permisos2[Permisos2["Reportes"] = 2] = "Reportes";
  Permisos2[Permisos2["Asistencia"] = 3] = "Asistencia";
  Permisos2[Permisos2["Ajustes"] = 4] = "Ajustes";
  Permisos2[Permisos2["Pedido"] = 5] = "Pedido";
  Permisos2[Permisos2["Factura"] = 6] = "Factura";
  Permisos2[Permisos2["Cartera"] = 7] = "Cartera";
  Permisos2[Permisos2["Visitas"] = 8] = "Visitas";
  Permisos2[Permisos2["Orden_Pedido"] = 9] = "Orden_Pedido";
  Permisos2[Permisos2["Consultar_Ventas"] = 10] = "Consultar_Ventas";
  Permisos2[Permisos2["Lectura_Acceso_total"] = 11] = "Lectura_Acceso_total";
  Permisos2[Permisos2["Escritura_Acceso_total"] = 12] = "Escritura_Acceso_total";
  Permisos2[Permisos2["Log\xEDstica"] = 13] = "Log\xEDstica";
  return Permisos2;
}({});
var estadoUsuario = /* @__PURE__ */ function(estadoUsuario2) {
  estadoUsuario2["Activo"] = "A";
  estadoUsuario2["Pendiente"] = "P";
  return estadoUsuario2;
}({});
var estadoMOVIMIENTOCABECERA = /* @__PURE__ */ function(estadoMOVIMIENTOCABECERA2) {
  estadoMOVIMIENTOCABECERA2["Activo"] = "A";
  estadoMOVIMIENTOCABECERA2["Anulado"] = "I";
  return estadoMOVIMIENTOCABECERA2;
}({});
var porcentajeIVA = /* @__PURE__ */ function(porcentajeIVA2) {
  porcentajeIVA2[porcentajeIVA2["Ecuador"] = 15] = "Ecuador";
  return porcentajeIVA2;
}({});
var Ecuador = class {
};
__name(Ecuador, "Ecuador");
__publicField(Ecuador, "porcentajeIva", 15);
var logisticaManifiestoEstado = /* @__PURE__ */ function(logisticaManifiestoEstado2) {
  logisticaManifiestoEstado2["Anulado"] = "I";
  logisticaManifiestoEstado2["Activo"] = "A";
  return logisticaManifiestoEstado2;
}({});
var estadoLogisticaManifiestoProformaDetalle = /* @__PURE__ */ function(estadoLogisticaManifiestoProformaDetalle2) {
  estadoLogisticaManifiestoProformaDetalle2["Pendiente"] = "P";
  estadoLogisticaManifiestoProformaDetalle2["Anulado"] = "I";
  estadoLogisticaManifiestoProformaDetalle2["Convertido"] = "C";
  return estadoLogisticaManifiestoProformaDetalle2;
}({});
var logisticaManifiestoDetalleEstado = /* @__PURE__ */ function(logisticaManifiestoDetalleEstado2) {
  logisticaManifiestoDetalleEstado2["Anulado"] = "I";
  logisticaManifiestoDetalleEstado2["Activo"] = "A";
  logisticaManifiestoDetalleEstado2["Convertido"] = "C";
  logisticaManifiestoDetalleEstado2["EnRuta"] = "U";
  return logisticaManifiestoDetalleEstado2;
}({});
var tiposImporteCabecera = /* @__PURE__ */ function(tiposImporteCabecera2) {
  tiposImporteCabecera2["importe"] = "IM";
  tiposImporteCabecera2["formaDePago"] = "FP";
  tiposImporteCabecera2["devolucionDinero"] = "DD";
  return tiposImporteCabecera2;
}({});
var TiposDocumento = /* @__PURE__ */ function(TiposDocumento2) {
  TiposDocumento2[TiposDocumento2["-"] = 0] = "-";
  TiposDocumento2[TiposDocumento2["+"] = 1] = "+";
  TiposDocumento2["noDefinido"] = " ";
  return TiposDocumento2;
}({});
var TiposAPI = /* @__PURE__ */ function(TiposAPI2) {
  TiposAPI2[TiposAPI2["API_INSELEC"] = 1] = "API_INSELEC";
  TiposAPI2[TiposAPI2["API_PROMESA"] = 2] = "API_PROMESA";
  return TiposAPI2;
}({});
var logisticaOrigen = /* @__PURE__ */ function(logisticaOrigen2) {
  logisticaOrigen2[logisticaOrigen2["IngresoManual"] = 1] = "IngresoManual";
  logisticaOrigen2[logisticaOrigen2["ImportadoExcel"] = 2] = "ImportadoExcel";
  logisticaOrigen2[logisticaOrigen2["API_Promesa"] = 3] = "API_Promesa";
  logisticaOrigen2[logisticaOrigen2["GuiaProforma"] = 4] = "GuiaProforma";
  logisticaOrigen2[logisticaOrigen2["API_Inselec"] = 5] = "API_Inselec";
  logisticaOrigen2[logisticaOrigen2["API_PCGerente"] = 6] = "API_PCGerente";
  return logisticaOrigen2;
}({});
var AppsDeOrigen = /* @__PURE__ */ function(AppsDeOrigen2) {
  AppsDeOrigen2[AppsDeOrigen2["PCGerenteWPF"] = 1] = "PCGerenteWPF";
  AppsDeOrigen2[AppsDeOrigen2["PCGerenteAPI"] = 2] = "PCGerenteAPI";
  AppsDeOrigen2[AppsDeOrigen2["WebLogistica"] = 3] = "WebLogistica";
  AppsDeOrigen2[AppsDeOrigen2["PCGerenteMovilCXC"] = 4] = "PCGerenteMovilCXC";
  AppsDeOrigen2[AppsDeOrigen2["PCGerenteMovil"] = 5] = "PCGerenteMovil";
  AppsDeOrigen2[AppsDeOrigen2["PCGerenteBlazor"] = 6] = "PCGerenteBlazor";
  return AppsDeOrigen2;
}({});
var E_AMBIENTE = /* @__PURE__ */ function(E_AMBIENTE2) {
  E_AMBIENTE2[E_AMBIENTE2["Pruebas"] = 1] = "Pruebas";
  E_AMBIENTE2[E_AMBIENTE2["Produccion"] = 2] = "Produccion";
  E_AMBIENTE2[E_AMBIENTE2["Ninguno"] = 0] = "Ninguno";
  return E_AMBIENTE2;
}({});
var TipoCanalVenta = /* @__PURE__ */ function(TipoCanalVenta2) {
  TipoCanalVenta2[TipoCanalVenta2["VentaDirecta"] = 1] = "VentaDirecta";
  TipoCanalVenta2[TipoCanalVenta2["Aplicaciones_Uber"] = 2] = "Aplicaciones_Uber";
  TipoCanalVenta2[TipoCanalVenta2["web"] = 3] = "web";
  return TipoCanalVenta2;
}({});
var TiposIVA = /* @__PURE__ */ function(TiposIVA2) {
  TiposIVA2[TiposIVA2["BaseCero"] = 1] = "BaseCero";
  TiposIVA2[TiposIVA2["BaseIVA"] = 2] = "BaseIVA";
  TiposIVA2[TiposIVA2["NoObjeto"] = 3] = "NoObjeto";
  TiposIVA2[TiposIVA2["IVACargadoGasto"] = 4] = "IVACargadoGasto";
  TiposIVA2[TiposIVA2["IVA5"] = 5] = "IVA5";
  return TiposIVA2;
}({});
var logisticaTipoMedida = /* @__PURE__ */ function(logisticaTipoMedida2) {
  logisticaTipoMedida2[logisticaTipoMedida2["KG"] = 1] = "KG";
  logisticaTipoMedida2[logisticaTipoMedida2["M3"] = 2] = "M3";
  logisticaTipoMedida2[logisticaTipoMedida2["Bulto"] = 3] = "Bulto";
  return logisticaTipoMedida2;
}({});
var logisticaTipoContenido = /* @__PURE__ */ function(logisticaTipoContenido2) {
  logisticaTipoContenido2[logisticaTipoContenido2["Normal"] = 1] = "Normal";
  logisticaTipoContenido2[logisticaTipoContenido2["Adicional"] = 2] = "Adicional";
  logisticaTipoContenido2[logisticaTipoContenido2["Minimo"] = 3] = "Minimo";
  return logisticaTipoContenido2;
}({});
var LogisticaTipoCanal = /* @__PURE__ */ function(LogisticaTipoCanal2) {
  LogisticaTipoCanal2[LogisticaTipoCanal2["Tradicional"] = 1] = "Tradicional";
  LogisticaTipoCanal2[LogisticaTipoCanal2["Moderno"] = 2] = "Moderno";
  return LogisticaTipoCanal2;
}({});
var logisticaTipoContenidoDominio = class {
  constructor(id, descripcion) {
    __publicField(this, "id");
    __publicField(this, "descripcion");
    this.id = id;
    this.descripcion = descripcion;
  }
  static obtener(tipo) {
    switch (tipo) {
      case 1:
        return new logisticaTipoContenidoDominio(tipo, "Normal");
      case 2:
        return new logisticaTipoContenidoDominio(tipo, "Adicional");
      case 3:
        return new logisticaTipoContenidoDominio(tipo, "Minimo");
    }
  }
};
__name(logisticaTipoContenidoDominio, "logisticaTipoContenidoDominio");

// src/utils/BigDecimal.ts
import Decimal from "decimal.js";
var BigDecimal = class extends Decimal {
  constructor(value) {
    let valorInstancia = 0;
    if (value === void 0) {
      valorInstancia = 0;
    } else {
      valorInstancia = value;
    }
    super(valorInstancia);
  }
};
__name(BigDecimal, "BigDecimal");

export {
  __name,
  __publicField,
  TiposVisitaSegunUbicacion,
  Movs,
  NivelLog,
  LogisticaTipoConversion,
  LogisticaEstadoConversion,
  LogisticaManifiestoDetalleEstado,
  TiposEmision,
  ConfiguracionesCorreo,
  TiposIdentificacion,
  ExisteEnEnum,
  LogisticaTiposRango,
  LogisticaGuiaProformaEstado,
  LogisticaManifiestoProformaEstado,
  LogisticaGuiaEstado,
  LogisticaTiposEntrega,
  LogisticaTiposFormaPago,
  LogisticaTipoFormaPagoDominio,
  SriDocs,
  Docs,
  DocumentoDominio,
  ContaDocs,
  ConfiguracionesEmpresa,
  TiposVisita,
  FormasPagoEspeciales,
  MovimientoCabeceraObservacionesEspeciales,
  TiposPago,
  TiposFormaPago,
  CuentasEnlace,
  Notificaciones,
  TablasTransacciones,
  HTTP_STATUS,
  ConstantesDocumentos,
  Modulos,
  Permisos,
  estadoUsuario,
  estadoMOVIMIENTOCABECERA,
  porcentajeIVA,
  Ecuador,
  logisticaManifiestoEstado,
  estadoLogisticaManifiestoProformaDetalle,
  logisticaManifiestoDetalleEstado,
  tiposImporteCabecera,
  TiposDocumento,
  TiposAPI,
  logisticaOrigen,
  AppsDeOrigen,
  E_AMBIENTE,
  TipoCanalVenta,
  TiposIVA,
  logisticaTipoMedida,
  logisticaTipoContenido,
  LogisticaTipoCanal,
  logisticaTipoContenidoDominio,
  BigDecimal
};
